/* eslint-disable import/prefer-default-export */
import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';
// template components
import DocumentLink from '@nmx/template/dist/componentLibrary/modules/DocumentLink';

export const DocumentLinkStyled = styled(DocumentLink)`
  ${({ theme }) => {
    const xlargeUp = theme.xlargeUp();
    const smallUp = theme.smallUp();
    let colWidth = '30%'; // xsmall default

    if(xlargeUp){
      colWidth  = '15%';
    } else if(smallUp){
      colWidth = '20%';
    }

    return css`
      .nmx-col:first-child {
        flex: 0 ${colWidth};
      }
      .nmx-icon {
        width:${rem(30)};
      }
    `;
  }}
`;

export const UlStyled = styled.ul`
  list-style: none;
  padding-left: 0;
`;
